<template>
  <a-modal
    :footer="null"
    :width="500"
    :afterClose="handleAfterClose"
    v-model:visible="visible"
    :title="title"
    :maskClosable="false"
    class="j-modal-box-shadow"
    :maskStyle="{ 'background-color': 'inherit' }"
  >
    <div>
      <a-form
        ref="form"
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item
          name="consignee"
          :label="$t('vehicle.consignee')"
          :rules="{
            type: 'string',
            required: true,
            message: $t('vehicle.consignee_msg')
          }"
        >
          <a-select v-model:value="form.consignee">
            <a-select-option
              v-for="c in consigneeDropdownList"
              :key="c.id"
              :value="c.companyName"
              >{{ c.companyName }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item
          name="quantity"
          :label="$t('vehicle.quantity')"
          :wrapperCol="{ span: 12 }"
          :rules="[
            {
              type: 'string',
              required: true,
              message: $t('vehicle.quantity_msg')
            },
            validateQuantity()
          ]"
        >
          <a-input type="number" v-model:value="form.quantity">
            <template #addonBefore>
              <MinusOutlined class="btn-icon" @click="substract" />
            </template>
            <template #addonAfter>
              <PlusOutlined class="btn-icon" @click="add" />
            </template>
          </a-input>
        </a-form-item>

        <a-form-item
          name="color"
          :label="$t('vehicle.color')"
          :rules="{
            type: 'string',
            required: true,
            message: $t('vehicle.color_msg')
          }"
        >
          <a-select v-model:value="form.color">
            <a-select-option
              v-for="c in colorDropdownList"
              :key="c.id"
              :value="c.vehicleColor"
              >{{ $t(c.vehicleColor) }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <div style="text-align: right;">
          <a-button
            :loading="loading"
            @click="handleCancel"
            class="j-outline-btn1 j-height-auto"
          >
            {{ $t('vehicle.cancel') }}
          </a-button>
          <a-button
            :loading="loading"
            @click="handleConfirm"
            type="primary"
            class="j-height-auto"
            style="margin-left: 10px;"
          >
            {{ $t('vehicle.confirm') }}
          </a-button>
        </div>
      </a-form>
    </div>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import { message } from 'ant-design-vue';
import numeral from 'numeral';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons-vue';
import {
  getAllCustomerCompany,
  addToCart,
  getAllVehicleColorList
} from '@/api/apis';
import { validateQuantity } from '@/utils/validate';

export default defineComponent({
  name: 'AddToCartModal',
  components: {
    MinusOutlined,
    PlusOutlined
  },
  props: {
    vehicle: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    }
  },
  emits: ['after-close'],
  data() {
    return {
      validateQuantity,
      loading: false,
      visible: true,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      form: {
        quantity: '1',
        consignee: undefined,
        color: undefined
      },
      title: this.$t('vehicle.form_title'),
      consigneeDropdownList: [],
      colorDropdownList: []
    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    handleAfterClose() {
      this.$emit('after-close');
    },
    async loadDropdownData() {
      const res = await Promise.all([
        getAllCustomerCompany({
          customerId: this.userInfo.id
        }),
        getAllVehicleColorList({})
      ]);

      if (res.length === 2 && res.every(s => s.success)) {
        this.consigneeDropdownList = res[0].result || [];
        this.colorDropdownList = res[1].result || [];
      }
    },
    substract() {
      const quantity = Number(this.form.quantity);
      if (!isNaN(quantity) && quantity > 1) {
        this.form = {
          ...this.form,
          quantity: String(quantity - 1)
        } as any;

        const form = (this.$refs as any).form;

        form.clearValidate('quantity');
      }
    },
    add() {
      this.form = {
        ...this.form,
        quantity: String(Number(this.form.quantity || 0) + 1)
      } as any;
      const form = (this.$refs as any).form;
      form.clearValidate('quantity');
    },
    handleCancel() {
      this.visible = false;
    },
    handleConfirm() {
      const form = (this.$refs as any).form;
      form
        .validate()
        .then(async () => {
          this.loading = true;
          const res = await addToCart({
            ...this.form,
            quantity: numeral(this.form.quantity).value(),
            customerId: this.userInfo.id,
            img: this.vehicle.showImg,
            attributeImg: this.vehicle.attributeImg,
            modelNum: this.vehicle.modelNum,
            name: this.vehicle.vehicleName,
            shoppingType: 1,
            unitPrice: this.vehicle.sellingPrice,
            unit: this.vehicle.unit,
            // 后端做报表用
            vehicleId: this.vehicle.id,
            vehicleType: this.vehicle.vehicleType
          });
          if (res.success) {
            this.handleCancel();

            message.success(this.$t(res.message));
          }

          this.loading = false;
        })
        .catch();
    }
  },
  created() {
    this.loadDropdownData();
  }
});
</script>

<style lang="scss" scoped>
::v-deep(.ant-btn) {
  padding: 10px 34px;
}
::v-deep(.ant-form-item-label) {
  text-align: left;
}
.btn-icon {
  cursor: pointer;
}
</style>
